import { ComingSoon } from '@backrs_ui/common-ui';

export const ComingSoonPage = () => {
  return <ComingSoon />;
};
